export default __webpack_public_path__ + "static/azuki-7bcff1178c3e6682e8c1989f801c2c4c.png";